<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4">정규표현식 설정</div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-switch v-model="pattern.ignoreRegexFlag" active-value="Y" inactive-value="N" @change="changeRegexFlag"></el-switch>
      </div>
    </el-row>
    <el-form :model="pattern">
      <el-row class="mr-b25">
        <el-form-item label="정규표현식" prop="patternRegex">
          <el-input :disabled="!regexFlag(pattern.ignoreRegexFlag)" type="textarea" v-model="pattern.patternRegex" resize="none"></el-input>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4">패턴 테스트</div>
        </div>
        <div class="vertical-center-box" align="right">
          <el-button type="primary" size="mini" :disabled="!regexFlag(pattern.ignoreRegexFlag)" @click="onPatternTest">테스트</el-button>
        </div>
      </el-row>
      <el-row class="mr-b15">
        <el-form-item label="테스트 로그" prop="testLogArea">
          <el-input v-model="testLogData" type="textarea" resize="none" :disabled="!regexFlag(pattern.ignoreRegexFlag)"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="파싱 로그" prop="testLogArea">
        </el-form-item>
      </el-row>
    </el-form>
    <el-row :gutter="20">
      <el-col :span="8">
        <draggable v-model="mappingData" class="list-drag-box" element="ul" @start="isDraggable=true" @end="isDraggable=false">
           <li v-for="item in mappingData" :key="item.value">
             <div class="label">{{item.fieldName}}</div>
           </li>
        </draggable>
      </el-col>
      <el-col :span="16">
        <el-input style="margin-bottom: 7px;" v-for="parsing in mappingData" :key="parsing.fieldName" readOnly v-show="!runTest"></el-input>
        <el-input style="margin-bottom: 7px;" v-for="parsing in parsingLogData" :key="parsing.data" v-model="parsing.data" readOnly v-show="runTest"></el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import draggable from 'vuedraggable';

export default {
  name: 'WParsingPatterRegexSetting',
  components: {
    draggable,
  },
  props: {
    addFlag: {
      type: Boolean,
    },
    patternInfo: {
      type: Object,
      default: null,
    },
    indexInfo: {
      type: Object,
      default: null,
    },
    patternField: {
      type: Array,
    },
  },
  data() {
    return {
      runTest: false,
      testLogData: '',
      parsingLogData: [],
      pattern: {},
      mappingData: [],
      patternFieldList: [],
    };
  },
  watch: {
    mappingData: {
      immediate: true,
      deep: true,
      handler() {
        const parsingLogList = [];
        this.patternFieldList.forEach((item) => {
          const parsingItem = {
            patternId: this.patternInfo.patternId,
            dataindexId: this.indexInfo.dataindexId,
            fieldId: item.fieldId,
            patternIdx: this.mappingData.map((field) => field.fieldName).indexOf(item.fieldName) + 1,
            mappingFlag: (isNil(item.mappingFlag) || item.mappingFlag === 'N') ? 'N' : 'Y',
          };
          parsingLogList.push(parsingItem);
        });
        this.$emit('setSelectParsingLog', parsingLogList);
      },
    },
    patternInfo: {
      immediate: true,
      deep: true,
      handler(value) {
        this.runTest = false;
        this.testLogData = '';
        if (!isEmpty(value)) {
          this.pattern = value;
        } else {
          this.pattern = {};
        }
      },
    },
  },
  methods: {
    /**
     * 체크한 필드만 보여준다 ref로 patternSettingPopup에서 호출
     * @author leesy918
     */
    setMappingField() {
      this.mappingData = this.patternField.filter((item) => item.mappingFlag === 'Y');
      this.patternFieldList = cloneDeep(this.patternField);
    },
    regexFlag(data) {
      return (data === 'Y');
    },
    changeRegexFlag(value) {
      if (value !== 'Y') {
        this.patternFieldList = [];
        this.pattern.patternRegex = '';
        this.pattern.parsingLog = [];
      }
    },
    /**
     * 작성한 정규표현식으로 테스트 로그를 파싱한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onPatternTest() {
      this.parsingLogData = [];
      const parsingRegex = new RegExp(this.pattern.patternRegex);
      const testMessage = this.testLogData;
      const result = parsingRegex.exec(testMessage);
      forEach(result, (item, index) => {
        if (index !== 0) {
          this.parsingLogData.push({ data: item });
        }
      });
      this.runTest = true;
    },

  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/components/ParsingPatternRegexSetting.vue